import React, { ReactElement } from "react";
import { IconProps } from "../Icon.types";

const AlertCircleIcon = ({
  size = "1em",
  fill = "#343A40",
  title = "",
  iconClass = "",
  className,
  ...props
}: IconProps): ReactElement => {
  return (
    <svg
      {...props}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      version="1.1"
      className={className || iconClass}
    >
      <title>{title}</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill={fill}>
          <path d="M12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 Z M12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 Z M12,15 C12.5522847,15 13,15.4477153 13,16 C13,16.5522847 12.5522847,17 12,17 C11.4477153,17 11,16.5522847 11,16 C11,15.4477153 11.4477153,15 12,15 Z M12,7 C12.5522847,7 13,7.44771525 13,8 L13,12 C13,12.5522847 12.5522847,13 12,13 C11.4477153,13 11,12.5522847 11,12 L11,8 C11,7.44771525 11.4477153,7 12,7 Z" />
        </g>
      </g>
    </svg>
  );
};

export { AlertCircleIcon };
